import { useEffect, useRef } from 'react';

export const usePerformanceTimer = (eventName: string, isLoading: boolean) => {
  const startTimeRef = useRef<number | null>(null);
  
  useEffect(() => {
    if (isLoading && startTimeRef.current === null) {
      // Start timing
      startTimeRef.current = performance.now();
      console.log(`🔄 [${eventName}] Loading started...`);
    } else if (!isLoading && startTimeRef.current !== null) {
      // End timing
      const endTime = performance.now();
      const duration = endTime - startTimeRef.current;
      console.log(`✅ [${eventName}] Loading completed in ${duration.toFixed(2)}ms`);
      
      // Log performance warning if it takes too long
      if (duration > 2000) {
        console.warn(`⚠️ [${eventName}] Slow loading detected: ${duration.toFixed(2)}ms`);
      }
      
      startTimeRef.current = null;
    }
  }, [isLoading, eventName]);
};
